import { useState } from "react";
import { Navbar, Nav, Button, Offcanvas, Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/logo.png";
import "./header.css";

export const Header = () => {
  const [show, setShow] = useState(false);
  const location = useLocation();

  return (
    <Navbar expand="lg" className="custom-navbar" fixed="top">
      <Container fluid className="navbar-inner">
        {/* Logo */}
        <Navbar.Brand as={Link} to="/" className="navbar-logo">
          <img src={logo} alt="Logo" height="36" />
        </Navbar.Brand>

        {/* Desktop nav pill */}
        <Nav className="nav-pill d-none d-lg-flex">
          <Nav.Link as={Link} to="/">Home</Nav.Link>
          <Nav.Link
            as={Link}
            to="/about"
            className={location.pathname === "/about" ? "active-nav" : ""}
          >
            About Us
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/services"
            className={location.pathname === "/services" ? "active-nav" : ""}
          >
            Services
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/projects"
            className={location.pathname === "/projects" ? "active-nav" : ""}
          >
            Projects
          </Nav.Link>
          {/* <Nav.Link href="#blog">Blog</Nav.Link> */}
          <Nav.Link
            as={Link}
            to="/contact"
            className={location.pathname === "/contact" ? "active-nav" : ""}
          >
            Contact Us
          </Nav.Link>
        </Nav>

        {/* Right side: Get Started + hamburger */}
        <div className="d-flex align-items-center gap-3">
          <Button as={Link} to="/contact" className="btn-get-in-touch d-none d-lg-inline-flex align-items-center gap-2">
            Get in touch <span className="arrow-icon">↗</span>
          </Button>

          {/* Mobile toggle */}
          <Navbar.Toggle
            aria-controls="offcanvas-nav"
            className="d-lg-none custom-toggler"
            onClick={() => setShow(true)}
          />
        </div>

        {/* Offcanvas for mobile */}
        <Offcanvas
          show={show}
          onHide={() => setShow(false)}
          placement="end"
          id="offcanvas-nav"
          className="offcanvas-menu"
        >
          <Offcanvas.Header closeButton closeVariant="white">
            <Offcanvas.Title>
              <img src={logo} alt="Logo" height="30" />
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="flex-column gap-2">
              <Nav.Link as={Link} to="/" onClick={() => setShow(false)}>Home</Nav.Link>
              <Nav.Link as={Link} to="/about" onClick={() => setShow(false)}>About</Nav.Link>
              <Nav.Link as={Link} to="/services" onClick={() => setShow(false)}>Services</Nav.Link>
              <Nav.Link as={Link} to="/projects" onClick={() => setShow(false)}>Projects</Nav.Link>
              <Nav.Link as={Link} to="/contact" onClick={() => setShow(false)}>Contact Us</Nav.Link>
            </Nav>
            {/* <Button className="get-started-btn mt-4 w-100">Get started</Button> */}
          </Offcanvas.Body>
        </Offcanvas>
      </Container>
    </Navbar>
  );
};
